import TripOverviewCard from '@/components/manage/change-trips/TripOverviewCard';
import {
  setChangeTripsSelectedTripId,
  type ChangeBookingFlow,
} from '@/features/manage/manageActions';
import {
  changeTripsOutboundTripIdSelector,
  changeTripsReturnTripIdSelector,
} from '@/features/manage/manageSelectors';
import { useDispatch, useSelector } from '@/store/utils';
import type { BookedTripDTO } from '@/types/dto/agent';
import { type FC } from 'react';

interface TripOverviewProps {
  trip: BookedTripDTO;
  changeFlow: ChangeBookingFlow;
}

const TripOverview: FC<TripOverviewProps> = ({ trip, changeFlow }) => {
  const dispatch = useDispatch();
  const outboundTripId = useSelector(changeTripsOutboundTripIdSelector);
  const returnTripId = useSelector(changeTripsReturnTripIdSelector);
  const selectedTripIdForDirection = trip.isOutbound
    ? outboundTripId
    : returnTripId;
  const isSelected = selectedTripIdForDirection === trip.id;

  const handleToggle = () => {
    if (!trip.id) return;
    dispatch(
      setChangeTripsSelectedTripId({
        tripId: isSelected ? null : trip.id,
        isOutbound: trip.isOutbound,
      })
    );
  };

  return (
    <TripOverviewCard
      trip={trip}
      changeFlow={changeFlow}
      isSelected={isSelected}
      onToggle={handleToggle}
    />
  );
};

export default TripOverview;
